// 1. IMPORTS
import { useState, createContext } from 'react'
import { IntlProvider } from 'react-intl'

import messagesEn from '@assets/data/locales/en.json'
import messagesVi from '@assets/data/locales/vi.json'

// 2. LOCALE CONFIGURATION & CONTEXT
const DEFAULT_LOCALE = 'vi'
const menuMessages = {
  en: messagesEn,
  vi: messagesVi
}

const Context = createContext()

// 3. COMPONENT & STATES
const IntlProviderWrapper = ({ children }) => {
  const [locale, setLocale] = useState(DEFAULT_LOCALE)

  // 4. EVENT HANDLERS
  const switchLanguage = lang => {
    if (!menuMessages[lang]) return
    setLocale(lang)
  }

  // 5. MAIN JSX
  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <IntlProvider key={locale} locale={locale} messages={menuMessages[locale]} defaultLocale={DEFAULT_LOCALE}>
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

// 6. EXPORTS
export { IntlProviderWrapper, Context as IntlContext }
